import { unblockCompanyBody } from '@planuze/admin-contracts';
import { toast } from '@planuze/ui';
import { useCompaniesContent } from '../../content/sections/companies.js';
import { useUnblockCompany } from '../../hooks/use-companies.js';
import { companyErrorMessage } from './company-error.js';
import { CompanyReasonDialog } from './company-reason-dialog.js';

interface Props {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly companyId: string;
  readonly companyName: string;
}

export function UnblockCompanyModal({ open, onClose, companyId, companyName }: Props) {
  const copy = useCompaniesContent();
  const unblock = useUnblockCompany(companyId);
  const confirm = (reason: string): void => {
    unblock.mutate(reason, {
      onSuccess: (outcome) => {
        if (outcome.status === 'partial_success') {
          toast.warning(
            copy.unblockModal.partialSuccess(companyName, outcome.failedSteps.join(', ')),
          );
        } else {
          toast.success(copy.unblockModal.success(companyName));
        }
        onClose();
      },
      onError: (err) => {
        toast.error(companyErrorMessage(err, copy.errors));
      },
    });
  };
  return (
    <CompanyReasonDialog
      open={open}
      onClose={onClose}
      title={copy.unblockModal.title(companyName)}
      description={copy.unblockModal.description}
      confirmLabel={copy.unblockModal.confirmLabel}
      pending={unblock.isPending}
      validate={(reason) => unblockCompanyBody.safeParse({ reason }).success}
      onConfirm={confirm}
    />
  );
}
